module.exports = __webpack_public_path__ + "img/desktop_step.400d30de.png";